<div (click)="toggleSelect()" class="module">
  <h4>{{page.page_title}} <span *ngIf="isSelected">✓</span></h4>
  <p>{{page.id}}</p>
  <div *ngIf="page.absolute_url"><a href="{{page.absolute_url}}">link</a></div>
  <img *ngIf="page.screenshot_peview_url" src="{{page.screenshot_preview_url}}" style="width: 200px"/>
  <img *ngIf="!page.screenshot_peview_url && masterPage && masterPage.screenshot_preview_url" src="{{masterPage.screenshot_preview_url}}" style="width: 200px"/>
</div>
